<template>
    <div class="modal-card" style="width: auto; min-width: 680px">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ activeFolderTitle }}</p>
        </header>
        <section class="modal-card-body">
            <loading v-if="loading"></loading>
            <div class="box-container" v-else>
                <div>
                    <o-button variant="light" size="small" @click="Back" :disabled="pos == 0">
                        <o-icon icon="angle-left"></o-icon>
                    </o-button>
                    <o-button
                        variant="light"
                        size="small"
                        @click="Forward"
                        :disabled="pos >= history.length - 1">
                        <o-icon icon="angle-right"></o-icon>
                    </o-button>
                </div>
                <div class="box-table">
                    <o-table :data="items" :defaultSort="['name', 'asc']">
                        <o-table-column field="Id" label="" v-slot="props">
                            <div class="box-table-thumbnail">
                                <div
                                    v-if="IsImageFile(props.row) && GetThumbnailSrc(props.row)"
                                    class="sharepoint-thumbnail sharepoint-thumbnail-clickable"
                                    @click.stop="PreviewImage(props.row)">
                                    <img :src="GetThumbnailSrc(props.row)" :alt="props.row.name" />
                                </div>
                                <div v-else-if="IsVideoFile(props.row) && GetThumbnailSrc(props.row)" class="sharepoint-thumbnail">
                                    <img :src="GetThumbnailSrc(props.row)" :alt="props.row.name" />
                                </div>
                                <o-icon icon="file-pdf" size="medium" v-else-if="IsPdfFile(props.row)"></o-icon>
                                <o-icon icon="file" size="medium" v-else-if="props.row.type === 'file'"></o-icon>
                                <o-icon icon="folder" size="medium" v-if="props.row.type === 'folder'"></o-icon>
                            </div>
                        </o-table-column>
                        <o-table-column field="name" label="File Name" sortable v-slot="props">
                            <div class="box-table-row">
                                {{ props.row.name }}
                            </div>
                        </o-table-column>
                        <o-table-column
                            field="modified_by.name"
                            label="Last Modified By"
                            sortable
                            v-slot="props">
                            {{ GetModifiedBy(props.row) }} on
                            {{ GetModifiedAt(props.row) }}
                        </o-table-column>
                        <o-table-column field="" label="" v-slot="props">
                            <div class="box-table-download">
                                <o-button
                                    variant="light"
                                    @click="DoAction(props.row)"
                                    v-if="props.row.type === 'file' && !select">
                                    <o-icon icon="download"></o-icon>
                                </o-button>
                                <o-button
                                    variant="light"
                                    @click="Select(props.row)"
                                    v-if="props.row.type === 'file' && select">
                                    <o-icon icon="file-check"></o-icon>
                                </o-button>
                                <o-button
                                    variant="light"
                                    @click="DoAction(props.row)"
                                    v-if="props.row.type === 'folder'">
                                    <o-icon icon="folder-open"></o-icon>
                                </o-button>
                            </div>
                        </o-table-column>
                    </o-table>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <o-button variant="light" @click="Close">Cancel</o-button>
        </footer>
    </div>
</template>
<script>
import { ref, computed, inject, onMounted } from "vue";
import sharepointImagePreviewModal from "@/components/modals/sharepointImagePreviewModal.vue";
export default {
    props: {
        title: {
            type: String,
            default: "Folder"
        },
        folderPath: {
            type: String,
            default: ""
        },
        sort: {
            type: String,
            default: null
        },
        direction: {
            type: [Number, Boolean],
            default: null
        },
        limit: {
            type: [String, Number],
            default: null
        },
        select: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const $http = inject("$http");
        const moment = inject("$moment");
        const oruga = inject("$oruga");

        const loading = ref(true);
        const items = ref([]);
        const history = ref([{ title: props.title, folderPath: props.folderPath }]);
        const pos = ref(0);
        const activeFolderTitle = ref(props.title);
        const activeFolderPath = ref(props.folderPath);

        const queryString = computed(() => {
            let qs = "";
            if (props.sort) {
                qs += "&sort=" + props.sort;
            }
            if (props.direction == 0 || props.direction == 1) {
                qs += "&direction=" + props.direction;
            }
            if (props.limit) {
                qs += "&limit=" + props.limit;
            }

            if (qs.length > 0) {
                qs = "?" + qs.substring(1);
            }
            return qs;
        });

        const BuildFolderUrl = (path) => {
            const normalizedPath = (path || "").replace(/^\/+|\/+$/g, "");
            let url = "/api/v2/sharepoint/folder";
            if (normalizedPath) {
                url += "?path=" + encodeURIComponent(normalizedPath);
            }

            if (!queryString.value) {
                return url;
            }

            return url + (url.indexOf("?") > -1 ? "&" : "?") + queryString.value.substring(1);
        };

        const Select = (row) => {
            context.emit("select", row);
            Close();
        };

        const DoAction = (item, options) => {
            if (item.type == "file") {
                Download(item);
            } else {
                GetFolder(item, options);
            }
        };

        const GetExtension = (row) => {
            return (row?.name || "").split(".").pop().toLowerCase();
        };

        const IsImageFile = (row) => {
            return row?.type === "file" && ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(GetExtension(row));
        };

        const IsVideoFile = (row) => {
            return row?.type === "file" && ["mp4", "mov", "m4v", "webm", "avi", "wmv"].includes(GetExtension(row));
        };

        const IsPdfFile = (row) => {
            return row?.type === "file" && GetExtension(row) === "pdf";
        };

        const GetThumbnailSrc = (row) => {
            return row?.thumbnail_url || "";
        };

        const GetPreviewSrc = (row) => {
            return row?.preview_url || row?.thumbnail_url || "";
        };

        const PreviewImage = (row) => {
            const src = GetPreviewSrc(row);
            if (!IsImageFile(row) || !src) {
                return;
            }

            oruga.modal.open({
                props: {
                    title: row.name,
                    src
                },
                component: sharepointImagePreviewModal,
                trapFocus: true
            });
        };

        const GetFolder = async (row, options) => {
            const nextPath = row?.path || row?.id || props.folderPath;

            if (row && history.value[pos.value + 1]?.folderPath == nextPath) {
                Forward();
                return;
            }
            if (!options?.firstRun) {
                pos.value += 1;
            }

            try {
                loading.value = true;
                const response = await $http.get(BuildFolderUrl(nextPath));
                if (row) {
                    if (pos.value >= history.value.length) {
                        history.value.push({
                            title: row.name,
                            folderPath: nextPath,
                            items: response.data.entries
                        });
                    } else {
                        history.value[pos.value] = {
                            title: row.name,
                            folderPath: nextPath,
                            items: response.data.entries
                        };
                    }
                    activeFolderTitle.value = row.name;
                    activeFolderPath.value = nextPath;
                } else {
                    history.value[pos.value]["items"] = response.data.entries;
                }
                items.value = response.data.entries;
                loading.value = false;
            } catch (err) {
                console.error(err);
                loading.value = false;
            }
        };

        const Download = async (row) => {
            try {
                const response = await $http.get(
                    "/api/v2/sharepoint/file/download?path=" + encodeURIComponent(row.path || row.id),
                    {
                        responseType: "blob"
                    }
                );

                const blob = response.data;
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", row.name);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(err);
            }
        };

        const GetModifiedBy = (row) => {
            return row?.modified_by?.name || "Unknown";
        };

        const GetModifiedAt = (row) => {
            if (!row?.modified_at) {
                return "-";
            }
            return moment(row.modified_at).format("MM/DD/YYYY h:mm");
        };

        const Back = () => {
            if (pos.value > 0) {
                pos.value -= 1;
                activeFolderTitle.value = history.value[pos.value].title;
                activeFolderPath.value = history.value[pos.value].folderPath;
                items.value = history.value[pos.value].items;
            }
        };

        const Forward = () => {
            if (pos.value < history.value.length - 1) {
                pos.value += 1;
                activeFolderTitle.value = history.value[pos.value].title;
                activeFolderPath.value = history.value[pos.value].folderPath;
                items.value = history.value[pos.value].items;
            }
        };

        const Close = () => {
            context.emit("close");
        };

        onMounted(() => {
            GetFolder(undefined, { firstRun: true });
        });

        return {
            loading,
            items,
            history,
            pos,
            activeFolderTitle,
            activeFolderPath,
            Close,
            DoAction,
            Select,
            GetThumbnailSrc,
            GetPreviewSrc,
            IsImageFile,
            IsVideoFile,
            IsPdfFile,
            PreviewImage,
            Back,
            Forward,
            GetModifiedBy,
            GetModifiedAt
        };
    }
};
</script>
<style lang="scss" scoped>
.box-table {
    width: 100%;
}
.box-promo-row {
    border: solid 1px #eee;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin: 10px 0;
}
.box-promo-thumbnail {
    height: 100px;
    width: 100px;
    padding: 0;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-promo-filename {
    flex-grow: 2;
    display: flex;
    align-items: center;
}

.box-promo-download {
    height: 100px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-table-row {
    & > td {
        padding-top: 12px;
    }
}
.box-table-thumbnail {
    height: 35px;
    width: 35px;
    margin-right: -10px;
    display: flex;
    align-items: center;
}

.sharepoint-thumbnail {
    width: 35px;
    height: 35px;
    border-radius: 4px;
    object-fit: cover;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
}

.sharepoint-thumbnail-clickable {
    border: none;
    padding: 0;
    cursor: pointer;
}

.box-table-filename {
    flex-grow: 2;
    display: flex;
    align-items: center;
}
.box-table-download {
    align-items: right;
    justify-content: right;
    float: right;
}
.box-table {
    margin-top: 10px;
    margin-bottom: 10px;
    td {
        padding-top: 12px;
    }
}
</style>
